import { useContext, useEffect, useRef } from 'react'
import { MyInfoContextProvider } from '../../../services/myInfo/myInfo'
import { getPLSMyInfoCallback } from '../../../services/ntuc/memberService/myinfo'
import { ActionType } from '../../../store/signup/SignupReducer'
import { useSignupStore } from '../../../store/signup/UserSignupStore'
import { SignupRoute, SignupRouteParams } from '../SignupFlow/SignupFlow'
import { searchParams } from '../../../helpers/search-params'
import { useCookies } from 'react-cookie'
import { Box, Card, CardMedia, Grid, Typography } from '@mui/material'
import pendingBanner from '../../../assets/payment_pending_banner.svg'
import { useTranslation } from 'react-i18next'

// Callback page for MyInfo workflow
function CallbackPage(props: SignupRouteParams) {
    const { onNavigateTo } = props
    const { t } = useTranslation(`myinfo`)
    const [, dispatch] = useSignupStore()
    const { setMyInfoData } = useContext(MyInfoContextProvider)
    const [cookies] = useCookies()
    const code = searchParams.code
    const error = searchParams.error
    const errorDescription = searchParams[`error-description`]
    const mobileNumberLength = 8
    // the MyInfo code is single use: exchange it once, even if this effect re-runs
    const exchangedCode = useRef<string | undefined>(undefined)

    useEffect(() => {
        const dispatchMyInfo = (content: any) => {
            const mobileNumber = content.user.mobileNumber ?? ``
            content.user.mobileNumber = mobileNumber.substr(Math.max(mobileNumber.length - mobileNumberLength, 0))
            return dispatch({
                type: ActionType.MY_INFO,
                value: content,
            })
        }

        if (error && errorDescription) {
            onNavigateTo(SignupRoute.Form)
        } else if (code && exchangedCode.current !== code) {
            exchangedCode.current = code
            getPLSMyInfoCallback(code)
                .then(response => response.data.content)
                .then(content => {
                    setMyInfoData(content)
                    dispatchMyInfo(content)
                })
                .catch(error => {
                    console.error(error?.response?.data ?? error)
                })
                .finally(() => {
                    onNavigateTo(SignupRoute.Form)
                })
        }
    }, [code, error, errorDescription, setMyInfoData, dispatch, onNavigateTo, cookies])

    return (
        <Box mt={{ xs: 0 }} padding={2}>
            <Grid container rowSpacing={3}>
                <Grid item m='auto' xs={12} md={12} hidden={!pendingBanner}>
                    <Grid container justifyContent="center">
                        <Grid item xs={12} md={8}>
                            <Card sx={{ border: `none`, boxShadow: `none` }}>
                                <CardMedia
                                    sx={{ width: `100%`, objectFit: `contain`, borderRadius: { xs: `20px`, md: `50px` } }}
                                    component="img"
                                    image={pendingBanner}
                                    alt="Pending MyInfo Banner"
                                />
                            </Card>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container item justifyContent="center" xs={12}>
                    <Typography id="pending-myinfo-title" textAlign="center" variant="h2">{t(`title`)}</Typography>
                </Grid>
                <Grid item justifyContent="center" xs={12}>
                    <Typography id="pending-myinfo-message" textAlign="center">{t(`message`)}</Typography>
                </Grid>
            </Grid >
        </Box>
    )
}

export default CallbackPage
